import { render } from "./ContentVideo.vue?vue&type=template&id=73204bfc&scoped=true"
import script from "./ContentVideo.vue?vue&type=script&lang=js"
export * from "./ContentVideo.vue?vue&type=script&lang=js"

import "./ContentVideo.vue?vue&type=style&index=0&id=73204bfc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jekr\\Documents\\arla-foods-sc-event-platform\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73204bfc"]])

export default __exports__